import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  IconNewWindow,
  Text,
  TextLink,
} from 'braid-design-system';
import { SeekPassIconVerified } from '@seek/certsy-ui';
import React from 'react';
import translations from '../.vocab';
import urls from 'src/constants/urls';

export const SEEKPassDisclaimer = () => {
  const { t } = useTranslations(translations);
  return (
    <Columns space="xxsmall">
      <Column width="content">
        <Text size="xsmall">
          <SeekPassIconVerified />
        </Text>
      </Column>
      <Column>
        <Text tone="secondary">
          {t(
            'Verified credentials can help you assess with confidence. However, as an employer you remain responsible for ensuring candidates meet legal requirements.',
          )}
        </Text>
        <Box paddingTop="medium">
          <Text tone="secondary">
            <TextLink
              href={urls.CERTSY_OFFICIAL_LINK}
              target="_blank"
              rel="noopener"
              icon={<IconNewWindow />}
              iconPosition="trailing"
            >
              {t('Find out more')}
            </TextLink>
          </Text>
        </Box>
      </Column>
    </Columns>
  );
};
